import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "Layer_1",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 482.9 241.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".st1{fill:#fff}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M482.9 233c0 4.7-3.8 8.5-8.5 8.5H8.5c-4.7 0-8.5-3.8-8.5-8.5V8.5C0 3.8 3.8 0 8.5 0h465.9c4.7 0 8.5 3.8 8.5 8.5z",
      style: {"fill":"#001522"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M85.3 202.9h-15l-35-42.9v42.9h-10v-51.4h14.9l35.1 43v-43h10zM158.2 202.9h-55.3v-51.4h53.4v9.1h-43.4v11.1H143v9.1h-30.2V194h45.3v8.9zM247.6 151.4l-17.5 51.4h-12l-12.3-43.1-12.3 43.1h-12L164 151.4h11.1l12.4 42.7 12.3-42.7h12l12.3 42.7 12.4-42.7zM304.6 164.2c-6.7-3.5-13.9-5.3-21.8-5.3-11.4 0-17.1 2-17.1 6.1 0 2.4 2.1 4 6.4 4.7 5.8.5 11.7 1 17.5 1.6 8.4.8 14.4 2.3 17.9 4.5 4 2.4 5.9 6 5.9 11 0 5.5-2.5 9.8-7.4 12.8s-12.1 4.5-21.4 4.5c-13.2 0-23.8-3-31.7-9l5.4-7.1c7.1 4.9 15.8 7.4 26.1 7.4 5.8 0 10.3-.7 13.5-2.2s4.8-3.4 4.8-5.9c0-2.7-1.9-4.6-5.8-5.8-2.2-.6-5.5-1-10.1-1.3-7.1-.3-11.5-.6-13.1-.8-6.3-.6-11-2-14-4.1q-4.5-3.15-4.5-9.3c0-4.9 2.4-8.8 7.2-11.6 4.8-2.9 11.6-4.3 20.3-4.3 11.6 0 21 2.5 28.1 7.5zM381.4 202.9h-55.3v-51.4h53.4v9.1h-43.4v11.1h30.2v9.1h-30.2V194h45.3zM455.9 163.8l-9.2 3.2q-8.25-8.1-21-8.1c-7.3 0-13.1 1.7-17.5 5-4.3 3.4-6.5 7.7-6.5 13 0 5.5 2.2 9.9 6.5 13.2s10.2 5 17.6 5q12.9 0 21-8.4l8.6 4.6c-7.6 8.5-17.5 12.8-29.8 12.8-10.3 0-18.5-2.5-24.9-7.6-6.3-5.1-9.5-11.6-9.5-19.6 0-8.3 3.6-15.1 10.8-20.3 6.2-4.6 13.9-6.9 23-6.9q19.2.15 30.9 14.1",
      class: "st1"
    }, null, -1))
  ]))
}
export default { render: render }